import { render } from "./searchPlaceComponent.vue?vue&type=template&id=65b6844f"
import script from "./searchPlaceComponent.vue?vue&type=script&lang=js"
export * from "./searchPlaceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__